import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import MainFleetManagement from "./MainFleetManagement";
import ViewTrucks from "./ViewTrucks";
import ViewFleetRoutes from "./ViewFleetRoutes";
import FormFleetRoute from "./FormFleetRoute";

// prettier-ignore
const RoutesFleetManagement = () => {
       return (
           <>
               <Route
                   path="fleet-management"
                   element={
                       <PrivateRoute role="admin" panelType="w">
                           <MainFleetManagement />
                       </PrivateRoute>
                   }
               />
                <Route
                    path="fleet-management/trucks"
                    element={
                        <PrivateRoute role="admin" panelType="w">
                            <ViewTrucks />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="fleet-management/routes"
                    element={
                        <PrivateRoute role="admin" panelType="w">
                            <ViewFleetRoutes />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="fleet-management/routes/:idParams"
                    element={
                        <PrivateRoute role="admin" panelType="w">
                            <FormFleetRoute />
                        </PrivateRoute>
                    }
                />
            </>
        );
}
export default RoutesFleetManagement;
